/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { LegacyFieldLayoutApp } from '@jira/admin-pages__legacy-field-layout-app/src/LegacyFieldLayoutApp.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyLegacyFieldLayoutPromise: LazyComponent<() => React.JSX.Element | null> =
	lazyForPaint<typeof LegacyFieldLayoutApp>(() => {
		return markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-admin-pages-legacy-field-layout", jiraSpaEntry: "async-admin-pages-legacy-field-layout" */ '@jira/admin-pages__legacy-field-layout-app/src/LegacyFieldLayoutApp.tsx'
			).then((bundle) => bundle.LegacyFieldLayoutApp),
		);
	});

export const LazyLegacyFieldLayoutPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyLegacyFieldLayoutPromise}
		pageId="jira-admin-pages-legacy-field-layout"
		shouldShowSpinner
	/>
);
